export default __webpack_public_path__ + "static/media/bannersweb_checoleyenda_amazon_330x330(3).f40362ba.jpg";